import { ContactSchema } from '../../.types/Contact.schema'
import { definitions } from '../../.types/Contact.schema.json'
import { DynamicSchema } from '@soniq/schema'
import { contactCleanValues } from './validation'

export type { ContactSchema } from '../../.types/Contact.schema'
export const contactJsonSchema = definitions.ContactSchema
export const contactSchema = DynamicSchema.new<ContactSchema>({
  id: 'ContactSchema',
  jsonSchema: { ...definitions.ContactSchema, definitions },
  cleanValuesOptions: contactCleanValues,
})
export * from './guards'
export * from './validation'
export * from './types'
